import React, {useEffect, useState} from 'react';
import {AppBar, Badge, Button, IconButton, makeStyles, Toolbar, Typography} from '@material-ui/core';
import {AccountCircle, Menu} from "@material-ui/icons";
import {authRepository} from "../Domain/Repositories/AuthRepository";
import UserModal from "./UiComponents/UserModal";

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  toolbar: {
    paddingRight: 24, // keep right padding when drawer closed
  },
  appBarOpen: {
    zIndex: theme.zIndex.drawer + 1,
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
  },
  appBarClosed: {
    zIndex: theme.zIndex.drawer + 1,
    width: `100%`,
  },
  menuButton: {
    marginRight: 36,
  },
  title: {
    flexGrow: 1,
  },
}));

interface HeaderBarProps
{
  showNavBarButton: boolean;
  navBarIsOpen: boolean;
  onToggleNavBar: () => void;
}

export default function HeaderBar(props: HeaderBarProps)
{
  const classes = useStyles();
  const {showNavBarButton, navBarIsOpen, onToggleNavBar} = props;

  const [userDialogOpen, setUserDialogOpen] = useState<boolean>(false);

  return (
    <>
      <AppBar position="absolute" className={navBarIsOpen ? classes.appBarOpen : classes.appBarClosed}>
        <Toolbar className={classes.toolbar}>
          {showNavBarButton && (
            <IconButton
              edge="start"
              color="inherit"
              aria-label="open drawer"
              onClick={onToggleNavBar}
              className={classes.menuButton}
            >
              <Menu/>
            </IconButton>
          )}
          <Typography component="h1" variant="h6" color="inherit" noWrap className={classes.title}>
            The Cube Admin Dashboard
          </Typography>

          {authRepository.user === undefined ? (
            <Button onClick={() => setUserDialogOpen(true)} color="inherit">
              Login
            </Button>
          ) : (
            <IconButton
              edge="end"
              color="inherit"
              aria-label="user dialog"
              onClick={() => setUserDialogOpen(true)}
              className={classes.menuButton}
            >
              <AccountCircle/>
            </IconButton>
          )}
        </Toolbar>
      </AppBar>

      <UserModal open={userDialogOpen} onClose={() => setUserDialogOpen(false)}/>
    </>
  );
}
